import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Pistachios.css";

export default function Pistachios() {
    const PistachiosProducts = [
        {
            id: 1,
            name: "IN-SHELL PISTACHIOS",
            image: "/assets/img/Pistachios/In-Shell-Pistachios.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium snack packs",
                        "Retail food products",
                        "Hospitality industry",
                        "Dry fruit gift boxes",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Natural presentation",
                        "Rich nutty flavor",
                        "High consumer demand",
                        "Excellent nutritional value",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "PISTACHIO KERNELS",
            image: "/assets/img/Pistachios/Pistachio-Kernels.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery products",
                        "Ice cream manufacturing",
                        "Chocolate production",
                        "Premium desserts",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Ready-to-use form",
                        "Beautiful green color",
                        "Rich taste and texture",
                        "High market demand",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Pistachios (Pista)"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Pistachio Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Pistachio (Pista) products sourced from
                        trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {PistachiosProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}